import React, { useRef } from 'react';
import './layout.css';
import Topnav from './topnav';
import Bottomnav from './bottomnav';
import blurredglass from '../assets/blurredglass.png';
import { useLocation } from 'react-router-dom';
import { useGsapChrome } from '../hooks/useGsapAnimations';
import FeedbackPopup from './feedbackpopup';

const Layout = (props) => {
  const layoutRef = useRef(null);
  const location = useLocation();

  useGsapChrome(layoutRef, location.pathname);

  return (
    <main className='app_layout' ref={layoutRef}>

      <img className='blurredg' src={blurredglass} alt="" />

      <Topnav />

      <div className='page_content'>
        {props.children}
      </div>

      <Bottomnav />

      <FeedbackPopup />

    </main>
  );
}

export default Layout;
